import React, { Component } from 'react';
import { toast } from 'react-hot-toast';
import ModalCarga from '../ModalCarga';
import { Table } from 'react-bootstrap';

class CorteDiario extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            ventaSeleccionada: [],
            tipo: 'usuario',
            detalle: 'ventas',
        }
    }

    componentDidMount = async () => {
        this.select();
    }

    componentDidUpdate = (prevProps) => {
        if ((prevProps.idSucursal !== this.props.idSucursal) || (prevProps.fecha !== this.props.fecha)) {
            this.select()
            this.setState({
                ventaSeleccionada: []
            })
        }
    }

    numberWithCommas = (x) => {
        x = Number(x).toFixed(2);
        if (x === 0) {
            return '0.00';
        }else{
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }

    select = async () => {  
        this.setState({ loading: true });
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'corteDiario', idSucursal: this.props.idSucursal, fecha: this.props.fecha })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                data: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    selectVenta = async (e) => {
        this.setState({ loading: true });
        let idVenta = e.target.id;
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ operacion: 'selectVenta', idVenta: idVenta })
        };
        const response = await fetch('https://admin.panaderialazcano.com/php/DB/reportes.php', requestOptions);
        const data = await response.json();
        console.log(data);
        if (data.error === 0) {
            this.setState({
                ventaSeleccionada: data,
                loading: false
            })
        }else{
            this.setState({
                loading: false
            })
            toast.error('Error al obtener datos');
            console.log(data.mensaje);
        }
    }

    onChangeValue = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        })
    }

    render() { 
        return ( 
            <>
                <ModalCarga show={this.state.loading}/>
                <div className="col-2">
                    <label className='ms-1' htmlFor="tipo">Tipo</label>
                    <select name="tipo" id="tipo" className='form-control' value={this.state.tipo} onChange={this.onChangeValue}>
                        <option value="horario">Por Hora</option>
                        <option value="usuario">Por Usuario</option>
                    </select>
                </div>
                <div className="col-2">
                    <label className='ms-1' htmlFor="detalle">Detalle</label>
                    <select name="detalle" id="detalle" className='form-control' value={this.state.detalle} onChange={this.onChangeValue}>
                        <option value="ventas">Ventas</option>
                        <option value="ventasExtra">Ventas Extra</option>
                        <option value="pedidos">Pedidos</option>
                        <option value="ingresos">Ingresos</option>
                        <option value="egresos">Egresos</option>
                    </select>
                </div>
                <div className="col-12 mt-3"/>
                {/* TABLAS POR HORARIO */
                this.state.tipo === 'horario' &&
                    <div className="row d-flex justify-content-center">
                        <div className="col-3">
                            {this.state.data.ventas &&
                                this.state.data.ventas.matutino &&
                                <table className='table table-bordered' style={{ width: '100%' }}>
                                    <thead className='bg-black text-white'>
                                        <tr className='text-center'>
                                            <th colSpan={2}>Matutino</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Ventas</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.ventas.matutino.total)}</td>
                                        </tr>
                                        <tr>
                                            <td>Pedidos</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.pedidos.matutino.total)}</td>
                                        </tr>
                                        <tr>
                                            <td>Ventas Extra</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.ventasExtra.matutino.total)}</td>
                                        </tr>
                                        <tr style={{ fontWeight: 'bold' }}>
                                            <td>Total</td>
                                            <td className='text-end'>${this.numberWithCommas(Number(this.state.data.ventas.matutino.total) + Number(this.state.data.pedidos.matutino.total) + Number(this.state.data.ventasExtra.matutino.total))}</td>
                                        </tr>
                                    </tbody>
                                </table>                        
                            }
                        </div>
                        <div className="col-3">
                            {this.state.data.ventas &&
                                this.state.data.ventas.vespertino &&
                                <table className='table table-bordered' style={{ width: '100%' }}>
                                    <thead className='bg-black text-white'>
                                        <tr className='text-center'>
                                            <th colSpan={2}>Vespertino</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Ventas</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.ventas.vespertino.total)}</td>
                                        </tr>
                                        <tr>
                                            <td>Pedidos</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.pedidos.vespertino.total)}</td>
                                        </tr>
                                        <tr>
                                            <td>Ventas Extra</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.ventasExtra.vespertino.total)}</td>
                                        </tr>
                                        <tr style={{ fontWeight: 'bold' }}>
                                            <td>Total</td>
                                            <td className='text-end'>${this.numberWithCommas(Number(this.state.data.ventas.vespertino.total) + Number(this.state.data.pedidos.vespertino.total) + Number(this.state.data.ventasExtra.vespertino.total))}</td>
                                        </tr>
                                    </tbody>
                                </table>                        
                            }
                        </div>
                        <div className="col-3">
                            {this.state.data.ventas &&
                                this.state.data.ventas.total &&
                                <table className='table table-bordered' style={{ width: '100%' }}>
                                    <thead className='bg-black text-white'>
                                        <tr className='text-center'>
                                            <th colSpan={2}>Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Ventas</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.ventas.total.total)}</td>
                                        </tr>
                                        <tr>
                                            <td>Pedidos</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.pedidos.total.total)}</td>
                                        </tr>
                                        <tr>
                                            <td>Ventas Extra</td>
                                            <td className='text-end'>${this.numberWithCommas(this.state.data.ventasExtra.total.total)}</td>
                                        </tr>
                                        <tr style={{ fontWeight: 'bold' }}>
                                            <td>Total</td>
                                            <td className='text-end'>${this.numberWithCommas(Number(this.state.data.ventas.total.total) + Number(this.state.data.pedidos.total.total) + Number(this.state.data.ventasExtra.total.total))}</td>
                                        </tr>
                                    </tbody>
                                </table>                        
                            }
                        </div>
                        <div className="col-3">
                            {this.state.data.ventas &&
                                this.state.data.ventas.total &&
                                <table className='table table-bordered' style={{ width: '100%' }}>
                                    <thead className='bg-black text-white'>
                                        <tr className='text-center'>
                                            <th colSpan={2}>A Entregar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Efectivo</td>
                                            <td className='text-end'>${this.numberWithCommas(Number(this.state.data.ventas.total.efectivo) + Number(this.state.data.pedidos.total.efectivo) + Number(this.state.data.ventasExtra.total.efectivo))}</td>
                                        </tr>
                                        <tr>
                                            <td>Transferencia</td>
                                            <td className='text-end'>${this.numberWithCommas(Number(this.state.data.ventas.total.transferencia) + Number(this.state.data.pedidos.total.transferencia) + Number(this.state.data.ventasExtra.total.transferencia))}</td>
                                        </tr>
                                        <tr style={{ fontWeight: 'bold' }}>
                                            <td>Total</td>
                                            <td className='text-end'>${this.numberWithCommas(Number(this.state.data.ventas.total.efectivo) + Number(this.state.data.pedidos.total.efectivo) + Number(this.state.data.ventasExtra.total.efectivo) + Number(this.state.data.ventas.total.transferencia) + Number(this.state.data.pedidos.total.transferencia) + Number(this.state.data.ventasExtra.total.transferencia))}</td>
                                        </tr>
                                    </tbody>
                                </table>                        
                            }
                        </div>
                    </div>                
                }
                {/* TABLAS POR USUARIO */
                this.state.tipo === 'usuario' &&
                    (this.state.data.porUsuario &&
                    this.state.data.porUsuario.length > 0 ?
                        <div className="row p-2 m-0" style={{ borderBottom: '1px solid gray' }}>
                            {
                                this.state.data.porUsuario.map((e) =>                                            
                                <div className="col-4" id={e.idUsuario} key={e.idUsuario}>
                                    <table className='table table-border' style={{ width: '100%', border: '2px solid gray' }}>
                                        <thead className='bg-black text-white'>
                                            <tr className='text-center'>
                                                <th colSpan={2}>{e.usuario}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className='text-center' style={{ backgroundColor: '#929450', fontWeight: 'bold', color: 'white' }}>
                                                <td>Ventas</td>
                                                <td className='text-end'>${this.numberWithCommas(e.total)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }}>Efectivo</td>
                                                <td className='text-end' style={{ fontWeight: 'bold' }}>${this.numberWithCommas(e.efectivo)}</td>
                                            </tr>
                                            <tr>
                                                <td>Transferencia/Tarjeta</td>
                                                <td className='text-end'>${this.numberWithCommas(e.transferencia)}</td>
                                            </tr>
                                            <tr>
                                                <td>Uber</td>
                                                <td className='text-end'>${this.numberWithCommas(e.uber)}</td>
                                            </tr>
                                            <tr className='text-center' style={{ backgroundColor: '#509294', fontWeight: 'bold', color: 'white' }}>
                                                <td>Ventas Extra</td>
                                                <td className='text-end'>${this.numberWithCommas(e.ventasExtraTotal)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }}>Efectivo</td>
                                                <td className='text-end' style={{ fontWeight: 'bold' }}>${this.numberWithCommas(e.ventasExtraEfectivo)}</td>
                                            </tr>
                                            <tr>
                                                <td>Transferencia</td>
                                                <td className='text-end'>${this.numberWithCommas(e.ventasExtraTransferencia)}</td>
                                            </tr>
                                            <tr className='text-center' style={{ backgroundColor: '#525094', fontWeight: 'bold', color: 'white' }}>
                                                <td>Pedidos</td>
                                                <td className='text-end'>${this.numberWithCommas(e.pedidosTotal)}</td>
                                            </tr>
                                            <tr>
                                                <td style={{ fontWeight: 'bold' }}>Efectivo</td>
                                                <td className='text-end' style={{ fontWeight: 'bold' }}>${this.numberWithCommas(e.pedidosEfectivo)}</td>
                                            </tr>
                                            <tr>
                                                <td>Transferencia</td>
                                                <td className='text-end'>${this.numberWithCommas(e.pedidosTransferencia)}</td>
                                            </tr>
                                            <tr className='text-center' style={{ backgroundColor: '#947450', fontWeight: 'bold', color: 'white' }}>
                                                <td>Ingresos</td>
                                                <td className='text-end'>${this.numberWithCommas(e.ingresos)}</td>
                                            </tr>
                                            <tr className='text-center' style={{ backgroundColor: '#945250', fontWeight: 'bold', color: 'white' }}>
                                                <td>Egresos</td>
                                                <td className='text-end'>${this.numberWithCommas(e.egresos)}</td>
                                            </tr>
                                            <tr className='bg-black text-white text-center' style={{ fontWeight: 'bold' }}>
                                                <td>Sobre</td>
                                                <td className='text-end'>${this.numberWithCommas(Number(e.efectivo)+Number(e.ventasExtraEfectivo)+Number(e.pedidosEfectivo)+Number(e.ingresos)-Number(e.egresos))}</td>
                                            </tr>
                                        </tbody>
                                    </table>   
                                </div>
                                )
                            }
                        </div>
                    :
                    <div className="row">
                        <div className="col-12 text-center">
                            No hay ventas registradas este día.
                        </div>
                    </div>
                    )
                }
                {
                    this.state.detalle === 'ventas' &&
                        /*    DETALLE DE VENTAS   */
                        <>
                            <div className="col-12 mt-4"/>
                            {/* TABLA LISTADO DE VENTAS */}
                            <>
                            <div className="col-4 mb-4" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                                    {
                                        this.state.data.ventas &&
                                        <>
                                            <Table bordered striped>
                                                <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr>
                                                        <th>Hora</th>
                                                        <th>Usuario</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.data.ventas.ventas &&
                                                        this.state.data.ventas.ventas.length > 0 ?
                                                            this.state.data.ventas.ventas.map((e) =>                                              
                                                            <tr key={e.idVenta} id={e.idVenta} onClick={this.selectVenta} style={{ fontWeight: this.state.ventaSeleccionada.idVenta === e.idVenta ? 'bold' : '' }}>
                                                                <td className='text-center' id={e.idVenta}>{new Date(e.fecha).toLocaleTimeString()}</td>
                                                                <td className='w-50' id={e.idVenta}>{e.usuario}</td>
                                                                <td className='text-center' id={e.idVenta}>${this.numberWithCommas(e.total)}</td>
                                                            </tr>                                            
                                                        )
                                                        :
                                                        <tr>
                                                            <td className="text-center" colSpan={3}>No hay ventas registradas éste día.</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </>
                                    }
                            </div>
                            </>
                            {/* TABLA DETALLE DE VENTAS */}
                            <>
                            <div className="col-8 mb-4" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                                {
                                    this.state.ventaSeleccionada.idVenta ?
                                        <Table striped>
                                            <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                <tr>
                                                    <th className='text-center col-12' colSpan={4}>Detalles de la Venta</th>
                                                </tr>
                                                <tr>
                                                    <th className='text-center col-3'>Fecha: {new Date(this.state.ventaSeleccionada.fecha).toLocaleDateString()}</th>
                                                    <th className='text-center col-3'>Hora: {new Date(this.state.ventaSeleccionada.fecha).toLocaleTimeString()}</th>
                                                    <th className='text-center col-3'>Pagado: {this.state.ventaSeleccionada.metodoPago.charAt(0).toUpperCase() + this.state.ventaSeleccionada.metodoPago.slice(1)}</th>
                                                    <th className='text-center col-3'>Total: ${this.numberWithCommas(this.state.ventaSeleccionada.total)}</th>
                                                </tr>
                                                <tr>
                                                    <th className='col-9' colSpan={3}>Comentario: {this.state.ventaSeleccionada.comentario}</th>
                                                    <th className='text-center col-3'>Usuario: {this.state.ventaSeleccionada.usuario}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr className='table-group-divider'>
                                                    <th>Producto</th>
                                                    <th className='text-center'>Precio Unitario</th>
                                                    <th className='text-center'>Cantidad</th>
                                                    <th className='text-center'>Importe</th>
                                                </tr>
                                                {
                                                    this.state.ventaSeleccionada.productos.map((e) =>                                            
                                                        <tr key={e.idProductoVenta}>
                                                            <td className=''>{e.nombre}</td>
                                                            <td className='text-center'>{'$' + this.numberWithCommas(e.precioUnitario)}</td>
                                                            <td className='text-center'>{e.cantidad}</td>
                                                            <td className='text-end'>{'$' + (Number(e.precioUnitario)*Number(e.cantidad))}</td>
                                                        </tr>                                            
                                                        )
                                                }
                                            </tbody>
                                        </Table>
                                    :
                                    <h1 className='text-center'>Seleccione una venta para ver el detalle</h1>
                                }
                            </div>
                            </>
                        </>
                }
                {
                    this.state.detalle === 'ventasExtra' &&
                        /*    DETALLE DE VENTAS  EXTRA  */
                        <>
                            <div className="col-12 mt-4"/>
                            {/* TABLA LISTADO DE VENTAS EXTRAS */}
                            <>
                            <div className="col-8 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                                    {
                                        this.state.data.ventasExtra &&
                                        <>
                                            <Table bordered striped>
                                                <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr>
                                                        <th>Hora</th>
                                                        <th>Usuario</th>
                                                        <th>Concepto</th>
                                                        <th style={{ whiteSpace: 'nowrap' }}>Método de Pago</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.data.ventasExtra.ventasExtra &&
                                                        this.state.data.ventasExtra.ventasExtra.length > 0 ?
                                                            this.state.data.ventasExtra.ventasExtra.map((e) =>                                              
                                                            <tr key={e.idVentaExtra} style={{ fontWeight: this.state.ventaSeleccionada.idVenta === e.idVenta ? 'bold' : '' }}>
                                                                <td className='text-center'>{new Date(e.fecha).toLocaleTimeString()}</td>
                                                                <td className='w-25'>{e.usuario}</td>
                                                                <td className='w-50'>{e.concepto}</td>
                                                                <td className='w-50' style={{ textTransform: 'capitalize' }}>{e.metodoPago}</td>
                                                                <td className='text-center'>${this.numberWithCommas(e.total)}</td>
                                                            </tr>                                            
                                                        )
                                                        :
                                                        <tr>
                                                            <td className="text-center" colSpan={3}>No hay ventas extra registradas éste día.</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </>
                                    }
                            </div>
                            </>
                        </>
                }
                {
                    this.state.detalle === 'pedidos' &&
                        /*    DETALLE DE PEDIDOS  */
                        <>
                            <div className="col-12 mt-4"/>
                            {/* TABLAS POR PEDIDO */}
                            <>
                            <div className="col-8 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                                    {
                                        this.state.data.pedidos &&
                                        this.state.data.pedidos.pedidos &&
                                        this.state.data.pedidos.pedidos.length > 0 ?
                                            this.state.data.pedidos.pedidos.map((e) =>  
                                                <Table bordered striped key={e.idPedido} className="mb-4">
                                                    <thead className='bg-black text-white'>
                                                        <tr>
                                                            <th colSpan={4} className="text-center">Pedido de {e.nombre}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colSpan={4} className="text-center bg-gray text-white">Pedido</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fecha: {e.fecha}</td>
                                                            <td>Usuario: {e.nombreUsuarioPedido}</td>
                                                            <td style={{ textTransform: 'capitalize' }}>Método de Pago: {e.metodoPagoOriginal}</td>
                                                            <td>Total: ${this.numberWithCommas(e.totalOriginal)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4} className="text-center bg-gray text-white">Anticipo</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={2} style={{ textTransform: 'capitalize' }}>Método de Pago: {e.metodoPagoAnticipoOriginal}</td>
                                                            <td colSpan={2}>Monto: ${this.numberWithCommas(e.anticipoOriginal)}</td>
                                                        </tr>
                                                        <tr>
                                                            <td colSpan={4} className="text-center bg-gray text-white">Entrega</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Usuario: {e.nombreUsuarioEntregado}</td>
                                                            <td>Fecha Prevista: {e.fechaEntregaProvista}</td>
                                                            <td>Fecha Real: {e.fechaEntrega}</td>
                                                            <td>Cobro: ${this.numberWithCommas(Number(e.totalOriginal)-Number(e.anticipoOriginal))}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>                                          
                                        )
                                        :
                                        <tr>
                                            <td className="text-center" colSpan={3}>No hay pedidos con algún pago éste día.</td>
                                        </tr>
                                    }
                            </div>
                            </>
                        </>
                }
                {
                    this.state.detalle === 'ingresos' &&
                        /*    DETALLE DE INGRESOS  */
                        <>
                            <div className="col-12 mt-4"/>
                            {/* TABLA LISTADO DE INGRESOS */}
                            <>
                            <div className="col-8 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                                    {
                                        this.state.data.ingresos &&
                                        <>
                                            <Table bordered striped>
                                                <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr>
                                                        <th>Hora</th>
                                                        <th>Usuario</th>
                                                        <th>Concepto</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.data.ingresos &&
                                                        this.state.data.ingresos.length > 0 ?
                                                            this.state.data.ingresos.map((e) =>                                              
                                                            <tr key={e.idIngreso}>
                                                                <td className='text-center'>{new Date(e.fecha).toLocaleTimeString()}</td>
                                                                <td className='w-25'>{e.usuario}</td>
                                                                <td className='w-50'>{e.concepto}</td>
                                                                <td className='text-center'>${this.numberWithCommas(e.total)}</td>
                                                            </tr>                                            
                                                        )
                                                        :
                                                        <tr>
                                                            <td className="text-center" colSpan={3}>No hay ingresos registrados éste día.</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </>
                                    }
                            </div>
                            </>
                        </>
                }
                {
                    this.state.detalle === 'egresos' &&
                        /*    DETALLE DE EGRESOS  */
                        <>
                            <div className="col-12 mt-4"/>
                            {/* TABLA LISTADO DE EGRESOS */}
                            <>
                            <div className="col-8 mb-4 mx-auto" style={{ maxHeight: '656px', overflowY: 'auto' }}>
                                    {
                                        this.state.data.egresos &&
                                        <>
                                            <Table bordered striped>
                                                <thead className='bg-black text-white' style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                    <tr>
                                                        <th>Hora</th>
                                                        <th>Usuario</th>
                                                        <th>Concepto</th>
                                                        <th>Total</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.data.egresos &&
                                                        this.state.data.egresos.length > 0 ?
                                                            this.state.data.egresos.map((e) =>                                              
                                                            <tr key={e.idEgreso}>
                                                                <td className='text-center'>{new Date(e.fecha).toLocaleTimeString()}</td>
                                                                <td className='w-25'>{e.usuario}</td>
                                                                <td className='w-50'>{e.concepto}</td>
                                                                <td className='text-center'>${this.numberWithCommas(e.total)}</td>
                                                            </tr>                                            
                                                        )
                                                        :
                                                        <tr>
                                                            <td className="text-center" colSpan={3}>No hay egresos registrados éste día.</td>
                                                        </tr>
                                                    }
                                                </tbody>
                                            </Table>
                                        </>
                                    }
                            </div>
                            </>
                        </>
                }
            </>
         );
    }
}
 
export default CorteDiario;